import React from "react"
import * as Icon from "react-feather"
const masterMenuConfig = [
  {
    id: "home",
    title: "Home",
    type: "item",
    icon: <Icon.Home size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/",
  },
  {
    id: "new_case",
    title: "New case ",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/patient",

  },
  {
    id: "existing_case",
    title: "Existing case ",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/patient",

  },
  {
    id: "provider_manager",
    title: "Provider Manager",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/patient",

  },
  {
    id: "insurance_manager",
    title: "Insurance Manager",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/patient",

  },
  {
    id: "label_manager",
    title: "Label Manager",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/patient",

  },
  {
    id: "hl7_orders",
    title: "HL7 Orders",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/patient",

  },
  {
    id: "hl7_delivery",
    title: "HL7 Delivery",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/patient",

  },

]

export default masterMenuConfig
